<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
import CcButton from '@/components/elements/CcButton';
import TooBusyButton from '@/components/elements/TooBusyButton';
import LabelCW from '@/components/elements/LabelCW';

export default {
    name: 'CollectTestCW',
    components: { TooBusyButton, Page, PageIntro, CcButton, LabelCW },
    data() {
        return {
            info: null,
            tooBusy: this.$config.tooBusy,
            token: null,
            fetching: null
        }
    },
    methods: {
        isNumber: function(evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        getToken() {
            if (this.token.length === 9) {
                this.fetching = true;
                this.$axios
                    .post(this.$config.apiacthealth + 'Personalias/ConfirmTestPersonalia', { token: this.token, languagenr: this.$store.state.languages.current.id }, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.accToken}`
                        }
                    })
                    .then(response => {
                        this.info = response.data
                        if (this.info) {
                            this.$store.state.pToken = this.token;
                            this.$router.push({ name: 'TestVerifyCW' });
                        } else {
                            this.fetching = false;
                            this.$store.commit('modal/set', {
                                messageHead: this.$t('message.error.tokenNotFound.head'),
                                messageBody: this.$t('message.error.tokenNotFound.body', { code: '404' }),
                                closeButton: true
                            });
                        }
                    })
                    .catch(error => {
                        this.fetching = false;
                        this.$store.commit('modal/set', {
                            messageHead: this.$t('message.error.tokenNotFound.head'),
                            messageBody: this.$t('message.error.tokenNotFound.body', { code: error }),
                            closeButton: true
                        });
                    })
            } else {
                this.$store.commit('modal/set', {
                    messageHead: this.$t('message.error.invalidTokenTest.head'),
                    messageBody: this.$t('message.error.invalidTokenTest.body'),
                    closeButton: true
                });
            }
        },
        back() {
            this.$router.push({ name: 'ChoiceProofCW' })
        }
    },
    computed: {
        testCode: {
            get() {
                return this.$store.state.testCode;
            },
            set(value) {
                // editing the test code should reset the process
                this.$store.commit('resetProvideCode');
                const strippedValue = value.replace(/ /g, '');
                const strippedValue2 = strippedValue.replace(/\t/g, '');
                const toUpperCase = strippedValue2.toUpperCase();
                this.$store.commit('updateProperty', { key: 'testCode', value: toUpperCase })
            }
        }
    }
}
</script>

<template>
    <Page
        @back="back">
        <div class="section">
            <p v-if="info">{{info.nam.fn }}</p>
            <PageIntro
                :head="$t('views.collectTestToken.pageHeader')"
                :intro="$t('views.collectTestToken.pageIntro')"/>
            <div class="section-block">
                 <div class="section-block__footer">
                     <labelCW :label="$t('Retrievalcode')" style="font-style: normal;"></labelCW>
                     <TooBusyButton v-if="tooBusy"/>
                     <div class="input__set">
                        <input @keypress="isNumber($event)" maxlength="9" v-model="token" id="input--testCode" type="text" :placeholder="$t('forInstanceAbbr') + ' 323776566'"/>
                     </div>
                     <CcButton v-if="!tooBusy" @select="getToken()" :label="$t('components.token.getToken')"/>
                     <div v-text="$t('onemoment')" v-if="fetching" class="OnemomentText"></div>
                </div>
            </div>
        </div>
    </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.ProvideTestCode {

    .UserConsent {
        margin-bottom: $length-s;
    }

    .OnemomentText {
        display: block;
        margin: 20px;
        padding-block: 30px;
        font-weight: bold;
    }
}
</style>
